import * as CodeMirror from 'codemirror';
const partStartingMark = {
  '/': 'compPath',
  '#': 'componentId',
  '^': 'parent'
};
CodeMirror.defineMode('uicore-comp-selector', () => ({
  startState() {
    return {
      inside: 'none',
      lastInside: 'none'
    };
  },
  token(stream, state) {
    state.lastInside = state.inside;
    switch (state.inside) {
      case 'none':
        {
          stream.eatSpace();
          const nextChar = stream.peek();
          if (nextChar) state.inside = partStartingMark[nextChar] || 'invalid';
          return null;
        }
      case 'compPath':
        {
          stream.match(/^\S+/);
          state.inside = 'none';
          return 'atom cs-compPath';
        }
      case 'parent':
        {
          stream.eat('^');
          const correct = stream.eol() || stream.match(/^\S*/);
          state.inside = correct ? 'none' : 'invalid';
          return 'string cs-parent';
        }
      case 'componentId':
        {
          stream.eat('#');
          const correct = stream.eol() || stream.match(/^\w+/);
          state.inside = correct ? 'none' : 'invalid';
          return 'builtin cs-componentId';
        }
      case 'invalid':
      default:
        {
          stream.skipToEnd();
          return 'error cs-invalid';
        }
    }
  },
  copyState(state) {
    return {
      ...state
    };
  }
}));
//# sourceMappingURL=compSelectorMode.js.map
